import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './Dashboard.vue'
import Login from './Login.vue'
// TODO import User from './Users.vue'
import Users from './Users.vue'
import Group from './Group.vue'
import Groups from './Groups.vue'
import Elevators from './Elevators.vue'
import Elevator from './Elevator.vue'
import Outages from './Outages.vue'
import Outage from './Outage.vue'
import Unconnected from './Unconnected.vue'
// import ElevatorInteraction from './ElevatorInteraction.vue'
import Events from './Events.vue'
import Activity from './Activity.vue'
import MapPage from './MapPage.vue'
import Maintenance from './Maintenance.vue'

import auth from './auth.js'
import api from './api.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Dashboard,
      beforeEnter: requireAuth,
    },
    {
      path: '/map',
      component: MapPage,
    },
    {
      path: '/login',
      component: Login
    },
    { 
      path: '/logout',
      beforeEnter (to, from, next) {
        auth.logout()
        location.reload()
      }
    },
    {
      path: '/users',
      component: Users,
      beforeEnter: requireAdminOrGroupAdmin
    },
    {
      path: '/groups',
      component: Groups,
      beforeEnter: requireAdmin
    },
    {
      path: '/groups/:id',
      name: 'group',
      component: Group,
      props: true
    },
    {
      path: '/groups/:id/evac',
      name: 'evac',
      component: Dashboard,
      beforeEnter (to, from, next) {
        api.putEvacGroup(to.params.id, true, () => {
          window.vue.$emit('get-groups');
        });
        next({
          path: from.fullPath,
        })
      }
    },
    {
      path: '/groups/:id/unevac',
      name: 'unevac',
      component: Dashboard,
      beforeEnter (to, from, next) {
        api.putEvacGroup(to.params.id, false, () => {
          window.vue.$emit('get-groups');
        });
        next({
          path: from.fullPath,
        })
      }
    },
    {
      name: 'elevators',
      path: '/lifts',
      component: Elevators,
      beforeEnter: requireAuth
    },
    {
      path: '/lifts/:id(.*[^/])/reset',
      name: 'reset',
      component: Elevator,
      beforeEnter: requireAuth,
      props: {
        reset: true,
      }
    },
    {
      path: '/lifts/:id(.*[^/])/delete',
      name: 'delete',
      component: Elevator,
      beforeEnter: requireAuth,
      props: {
        del: true,
      }
    },
    {
      path: '/lifts/:id(.*[^/])',
      name: 'elevator',
      component: Elevator,
      beforeEnter: requireAuth
    },
    {
      name: 'outages',
      path: '/breakdowns',
      component: Outages,
      beforeEnter: requireAuth
    },
    {
      name: 'outage',
      path: '/breakdown/:id',
      component: Outage,
      beforeEnter: requireAuth
    },
    {
      name: 'events',
      path: '/events',
      component: Events,
      beforeEnter: requireAuth
    },
    {
      name: 'event',
      path: '/event/:id',
      component: Outage,
      beforeEnter: requireAuth
    },
    {
      name: 'setup',
      path: '/setup',
      component: Unconnected,
      beforeEnter: requireAuth
    },
    {
      name: 'maintenance',
      path: '/maintenance',
      component: Maintenance,
      beforeEnter: requireAuth
    },
    {
      name: 'activity',
      path: '/activity',
      component: Activity,
      beforeEnter: requireAdminOrGroupAdmin
    },
    // {
    //   path: '/elevator/:id/interact',
    //   name: 'elevator-interaction',
    //   component: ElevatorInteraction,
    //   beforeEnter: requireAuth
    // },
  ]
})

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function requireAdmin (to, from, next) {
  if(!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if(!auth.admin()) {
      next({
        path: '/403',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
}

function requireAdminOrGroupAdmin (to, from, next) {
  if(!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if(!auth.admin() && !auth.groupAdmin()) {
      next({
        path: '/403',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router.js